<template>
  <span>
    <b-row>
      <b-col>
        <v-select
          id="filtroEmpresaSelect"
          v-model="selectModel"
          style="width: 300px;"
          :options="selectOptions"
          placeholder="Filtro por seleção de empresas"
          :close-on-select="false"
          :searchable="false"
          @input="retornarPadrao"
          @close="isDropdown = false"
          @open="isDropdown = true"
        >
          <!-- template para texto do model -->
          <template slot="selected-option">
            <b-badge>
              <span>
                {{ selectOptions.length }} empresa{{ selectOptions.length>1 ? 's' : '' }} selecionada{{ selectOptions.length>1 ? 's' : '' }}
              </span>
            </b-badge>
          </template>
          <!-- template para as opções -->
          <!-- <template #option="{ razaoSocial, id }"> Pega propriedade especifica do objeto -->
          <template
            slot="option"
            slot-scope="option"
          >
            <b-badge>
              <span style="font-weight: lighter; font-size: 11px">
                {{ formatarRazaoSocial(option.razaoSocial) }}
              </span>
              <button
                style="color: dimgrey; background: none; border: none; cursor: pointer; font-weight: bolder; width: 50px;"
                @click.stop="removerOpcao(option.id)"
              >
                <font-awesome-icon
                  icon="fa-times"
                  class="text-primary fa-lg"
                />
              </button>
            </b-badge>
          </template>
          <!-- template para caso não tiver opções -->
          <template slot="no-options">
            <span>Nenhuma empresa encontrada</span>
          </template>
          <!-- template para adicionar algo no campo -->
          <template #open-indicator>
            <font-awesome-icon
              :icon="'chevron-down'"
              :class="{ rotated: isDropdown }"
              class="dropdown-icon"
            />
          </template>
        </v-select>
      </b-col>
      <b-col
        style="padding-top: 10px !important;"
        class="p-0"
      >
        <button
          v-b-tooltip.hover
          :style="{ all: 'unset', cursor: 'pointer' }"
          :title="`Abrir seleção de empresa`"
          @click="abrirModal"
        >
          <font-awesome-icon
            :class="'text-primary'"
            icon="bars"
          />
        </button>
      </b-col>
    </b-row>
    <b-modal
      ref="modalFiltroSelecaoEmpresa"
      size="xl"
      :hide-header-close="true"
      modal-class="tamanho-modal"
      @hidden="fecharModal"
    >
      <template #modal-title>
        <b-row>
          <b-col>
            <h4>Dashboard por seleção de empresas - Filtro personalizado</h4>
          </b-col>
        </b-row>
        <fieldset
          class="font-weight-bold text-muted small d-flex flex-row align-items-center"
          style="gap: .3rem;"
        >
          <span>Selecione a(s) empresa(s) que deseja visualizar no dashboard</span>
        </fieldset>
      </template>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-btn
            variant="none"
            size="sm"
            class="btn-outline-success btn-none"
            style="margin-left: 0.3rem;"
            @click="getEmpresasFiltradas(), fecharModal()"
          >
            Salvar
          </b-btn>
          <b-btn
            variant="none"
            size="sm"
            class="btn-outline-danger btn-none"
            style="margin-left: 0.3rem;"
            @click="fecharModal()"
          >
            Cancelar
          </b-btn>
        </div>
      </template>
      <div>
        <vinculo-empresas
          v-model="empresasVinculadas"
          :cadastro-usuario="false"
          :visualizacao-opcoes="visualizacao"
          :tem-busca="true"
          :inverter-vincular-desvincular="true"
          :filtros-vinculadas="filtrosVinculadas"
          :filtros-nao-vinculadas="filtrosNaoVinculadas"
          :quantidade="45"
        />
      </div>
    </b-modal>
  </span>
</template>

<style lang="scss">

.tamanho-modal {
  margin-left: 18rem;
  width: calc(100% - 18rem);
}

// select invalido
.is-select-invalid > .vs__dropdown-toggle {
  border-color: #ea5455 !important;
  background-repeat: no-repeat !important;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) !important;
}

.select-base-clearable .vs__dropdown-option:first-child {
  padding:1rem;
}

// icone do select
.dropdown-icon {
  stroke-width: 50px;
  stroke: gray;
  opacity: 0.7;
  transition: transform 0.3s ease, stroke-width 0.3s ease;
}

// icone rotacionado (quando dropdown está aberto)
.dropdown-icon.rotated {
  transform: rotate(180deg);
}

</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import api from '../../services/api'

export default {
  components: {
    FontAwesomeIcon,
    vSelect,
    VinculoEmpresas: () => import('@pilar/components/vinculo-empresas/VinculoEmpresas.vue'),
  },
  props: {
  },
  data() {
    return {
      isDropdown: false,
      selectModel: [],
      selectOptions: [],
      filtroCustomData: '',
      visualizacao: {
        placeholderBusca: 'Busca por palavra chave e CNPJ/CPF',
        tituloVinculada: 'Empresas com permissão ativa',
        tituloDesvinculada: 'Empresas que devem ser consideradas no dashboard',
        customTitle: 'Selecione a(s) empresas que deseja visualizar no dashboard',
        customSubtitle: 'As empresas listadas abaixo possuem a configuração de permissão ativa',
        evento: api.getTotalEmpresasFiltrado,
      },
      filtrosVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosNaoVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      empresasVinculadas: {
        vinculadas: [],
        naoVinculadas: [],
        id: 0,
      },
      empresasVinculadasSalvas: {
        vinculadas: [],
        naoVinculadas: [],
        id: 0,
      },
    }
  },
  created() {
    api.getTotalEmpresas()
      .then(payload => {
        this.empresasVinculadas = payload.data
        this.salvarLista()
        this.selectOptions = this.empresasVinculadas.vinculadas
      })
      .catch(() => {
        this.$erro('Não foi possível buscar as empresas')
      })
  },
  methods: {
    abrirModal() {
      this.$refs.modalFiltroSelecaoEmpresa.show()
    },
    fecharModal() {
      this.pegarListaSalva()
      this.$refs.modalFiltroSelecaoEmpresa.hide()
    },
    getEmpresasFiltradas() {
      this.salvarLista()

      this.selectOptions = this.empresasVinculadas.naoVinculadas
      if (this.selectOptions.length > 0) {
        this.selectModel = ['']
      } else {
        this.selectModel = []
      }

      this.$emit('empresa-filtrada', this.empresasVinculadas.naoVinculadas.map(empresa => empresa.id))
    },
    removerOpcao(id) {
      if (this.empresasVinculadas.naoVinculadas.length === 0) {
        this.empresasVinculadas.naoVinculadas = this.empresasVinculadas.vinculadas
        this.empresasVinculadas.vinculadas = []
      }
      const empresa = this.empresasVinculadas.naoVinculadas.find(option => option.id === id)
      this.empresasVinculadas.vinculadas.push(empresa)
      this.empresasVinculadas.naoVinculadas = this.empresasVinculadas.naoVinculadas.filter(option => option.id !== id)

      this.salvarLista()

      if (this.empresasVinculadas.naoVinculadas.length === 0) {
        this.selectModel = []
        this.selectOptions = this.empresasVinculadas.vinculadas
      } else {
        this.selectOptions = this.empresasVinculadas.naoVinculadas
      }

      this.$emit('empresa-filtrada', this.empresasVinculadas.naoVinculadas.map(empres => empres.id))
    },
    formatarRazaoSocial(razaoSocial) {
      const tamanhoMaximo = 20
      if (razaoSocial.length > tamanhoMaximo) {
        return `${razaoSocial.substring(0, tamanhoMaximo)}...`
      }
      return razaoSocial
    },
    retornarPadrao() {
      if (this.selectModel === null) {
        this.empresasVinculadas.vinculadas.push(...this.empresasVinculadas.naoVinculadas)
        this.empresasVinculadas.naoVinculadas = []
        this.salvarLista()
        this.selectOptions = this.empresasVinculadas.vinculadas
        this.$emit('empresa-filtrada', this.empresasVinculadas.naoVinculadas.map(empres => empres.id))
      }
    },
    pegarListaSalva() {
      // utiliza como base a lista salva
      // retira das vinculadas e coloca nas não vinculadas
      this.empresasVinculadasSalvas.vinculadas.forEach(id => {
        const empres = this.empresasVinculadas.naoVinculadas.find(empresa => empresa.id === id)
        if (empres) {
          this.empresasVinculadas.vinculadas.push(empres)
          this.empresasVinculadas.naoVinculadas = this.empresasVinculadas.naoVinculadas.filter(option => option.id !== id)
        }
      })
      // retira das não vinculadas e coloca nas vinculadas
      this.empresasVinculadasSalvas.naoVinculadas.forEach(id => {
        const empres = this.empresasVinculadas.vinculadas.find(empresa => empresa.id === id)
        if (empres) {
          this.empresasVinculadas.naoVinculadas.push(empres)
          this.empresasVinculadas.vinculadas = this.empresasVinculadas.vinculadas.filter(option => option.id !== id)
        }
      })
      // atualiza as opções
      if (this.empresasVinculadas.naoVinculadas.length === 0) {
        this.selectOptions = this.empresasVinculadas.vinculadas
      } else {
        this.selectOptions = this.empresasVinculadas.naoVinculadas
      }
    },
    salvarLista() {
      // salva para poder utilizar caso seja cancelado
      this.empresasVinculadasSalvas.vinculadas = this.empresasVinculadas.vinculadas.map(empresa => empresa.id)
      this.empresasVinculadasSalvas.naoVinculadas = this.empresasVinculadas.naoVinculadas.map(empresa => empresa.id)
    },
  },
}
</script>
